import { render, staticRenderFns } from "./cataractnnvmpListMobilehco.vue?vue&type=template&id=33b062d9"
import script from "./cataractnnvmpListMobilehco.vue?vue&type=script&lang=js"
export * from "./cataractnnvmpListMobilehco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports